import React, { PureComponent } from "react";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import Header from "../../../../containers/Header";
import { useNavigate } from "react-router-dom";
import BackIcon from "../../../../assets/svg/BackIcon";

function BeforeWithdrawalPolicy() {
  const navigate = useNavigate();
  return (
    <>
      <Header />

      <main className="main static-page">
        <div className="container">
          <div className="headingSec">
            <h4> Withdrawal Policy - Balajiwins</h4>
            <div className="back-link" onClick={() => navigate(-1)}>
              <BackIcon /> Back
            </div>
          </div>

          <div className="content">
            <h5>Processing Time</h5>
            <p>
              All withdrawals are typically processed within 24 hours. Delays
              may occur during high-volume periods or if additional verification
              is required.
            </p>
            <h5>KYC Verification</h5>
            <p>
              In some cases, we may request KYC (Know Your Customer)
              verification before processing a withdrawal. This may include:
            </p>
            <p className="privacy-points">1. A government-issued photo ID</p>
            <p className="privacy-points">
              2. A recent utility bill or bank statement as proof of address
            </p>
            <p className="privacy-points">
              3. A selfie with your ID for security confirmation
            </p>

            <p>
              {" "}
              KYC is only required in specific situations such as suspicious
              activity, high withdrawal amounts, or to comply with regulations.
            </p>
            <h5> Same Method Policy</h5>
            <p>
              {" "}
              Withdrawals must be made to the same wallet or account used for
              the deposit, where technically possible. If that method does not
              support withdrawals, you will be asked to provide an alternative
              after verification.
            </p>
            <h5>Limits</h5>
            <p className="privacy-points">1.Minimum withdrawal: $50</p>
            <p className="privacy-points">
              2. Maximum withdrawal per day: $5,000 (amounts above may require
              additional processing time and approval)
            </p>
            <h5> Important Notes</h5>
            <p>
              All bonuses must be fully wagered before requesting a withdrawal
            </p>

            <p>
              {" "}
              We do not charge withdrawal fees, but network (gas) or processor
              fees may apply
            </p>

            <p>
              {" "}
              Accounts found using VPNs, duplicate profiles, or falsified
              documents may face delays or forfeiture of funds.
            </p>

            <p>
              By submitting a withdrawal request, you acknowledge and agree to
              the above terms.
            </p>
          </div>
        </div>
      </main>

      <BeforeLoginFooter />
    </>
  );
}

export default BeforeWithdrawalPolicy;
